import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'routerSolutionsBrands'
})
export class RouterSolutionsBrandsPipe implements PipeTransform {
  transform(value: any, categoria?: string | number, type?: string, arg?: string): any {
    if (type === 'marca') {
      return '/l/' + 'marcas/' +
        value + '/' + '-' +
        '/pages/' + 1 + '/order/H/' + '/existencia/' +
        0 + '/marca/' + arg + '/grupo/' + 'null';
    } else if (type === 'soluciones') {
      return '/l/' + 'soluciones/' +
        value + '/' + categoria +
        '/pages/' + 1 + '/order/H/' + '/existencia/' +
        0 + '/marca/' + 'null' + '/grupo/' + arg;
    } else if (type === 'componentes') {

    }
  }
}
